module.exports = __webpack_public_path__ + "img/19.1.B.48046b66.png";